import truncateHtml from './truncateHtml';
export const utils = {
  truncateHtml
};
flarum.reg.add('lcoy-synopsis', 'forum/utils', null);